import { ListItem } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

interface AppSelectOptionProp<T> {
  handleClick: (t: AppSelectOption<T>) => void;
  isActive: boolean;
  isDisabled: boolean;
  option: AppSelectOption<T>;
  itemStyle?: React.CSSProperties;
}

export default function AppSelectOption<T>({
  handleClick,
  option,
  isActive,
  isDisabled,
  itemStyle,
}: AppSelectOptionProp<T>) {
  let style = {};
  if (isActive) {
    style = {
      maskImage: "url('/icons/icon_check.svg')",
      backgroundColor: "#1272EF",
    };
  }

  let backgroundColor = "transparent";
  if (isDisabled && !isActive) {
    backgroundColor = "#EFEFED";
  }

  return (
    <ListItem
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      borderBottom={"0.5px solid #D4D4D1"}
      whiteSpace={"nowrap"}
      p={"8px 16px"}
      as={"button"}
      onClick={(event) => {
        if (isDisabled && !isActive) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        handleClick(option);
      }}
      // 키보드 네비게이션:
      //  ↓: 다음 옵션, ↑: 이전 옵션, 맨 위 옵션에서 ↑이면 검색 input(있을 때)으로 복귀.
      //  Enter/Space는 button 기본 동작이 click을 발동.
      onKeyDown={(event) => {
        const target = event.currentTarget as HTMLElement;
        if (event.key === "ArrowDown") {
          event.preventDefault();
          const next = target.nextElementSibling as HTMLElement | null;
          next?.focus();
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          const prev = target.previousElementSibling as HTMLElement | null;
          if (prev) {
            prev.focus();
          } else {
            // 첫 옵션 — List(<ul>)의 이전 sibling이 검색 input이면 거기로 포커스.
            const list = target.parentElement;
            const beforeList = list?.previousElementSibling as HTMLElement | null;
            if (beforeList && beforeList.tagName === "INPUT") {
              beforeList.focus();
            }
          }
        }
      }}
      backgroundColor={backgroundColor}
      _before={{
        content: '""',
        display: "inline-block",
        width: "12px",
        height: "12px",
        marginRight: "8px",
        ...style,
      }}
      _hover={
        isDisabled
          ? {}
          : {
              cursor: "pointer",
              "::before": {
                backgroundColor: "#444440",
                maskImage: "url('/icons/icon_check.svg')",
                ...style,
              },
            }
      }
      style={itemStyle}
    >
      {option.component || <Text>{option.name}</Text>}
    </ListItem>
  );
}
